import Stack from "ui/Stack";
import Typography from "ui/Typography";
import { SurfaceType } from "utils/analytics/analyticsConstants";
import { AnalyticsProvider } from "utils/analytics/AnalyticsContext";
import styled from "styled-components/macro";
import AlongLogo from "components/AlongLogo";
import GuestLayout from "components/GuestLayout/GuestLayout";
import Underline from "images/underline.svg";
import SelectUserType from "./SelectUserType";

/*
  The teacher avatar is slightly taller than the student,
  which is why the padding differs
*/
const $PageHeader = styled.div`
  display: flex;
  text-align: center;
  align-items: flex-start;
  gap: ${({ theme }) => theme.SizeMd};

  & > #teacherAvatar {
    padding-top: 2.5rem;
  }

  & > #studentAvatar {
    padding-top: 3rem;
  }

  & > #studentAvatar,
  & > #teacherAvatar {
    @media screen and (${({ theme }) => theme.BreakpointTabletDown}) {
      display: none;
    }
  }
`;

const $ContentContainer = styled(Stack).attrs({
  $align: "center",
  $space: "SizeMd",
})`
  padding: 2rem 0;
  text-align: center;

  .mb-4 {
    padding: 0;
  }
  max-width: 24rem;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
`;

const $AlongLogoContainer = styled.div`
  padding-top: 2rem;
  padding-bottom: 2rem;
`;

const $ConnectionsContainer = styled.span`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -0.4rem;
    left: -0.5rem;
    right: -0.5rem;
    height: 1.3rem;
    background-image: url(${Underline});
    background-repeat: no-repeat;
    background-size: contain;
  }
`;

export default function CreateAccount() {
  return (
    <AnalyticsProvider surface={SurfaceType.SELECT_USER_TYPE}>
      <GuestLayout userType="teacher">
        <$ContentContainer>
          <$PageHeader>
            <Stack $align="center" $space="SizeXl">
              <$AlongLogoContainer>
                <AlongLogo size="standard" variant="along-2" />
              </$AlongLogoContainer>
              <Typography size="h1" fontWeight="normal">
                Start building better{" "}
                <$ConnectionsContainer>connections</$ConnectionsContainer> today
              </Typography>
            </Stack>
          </$PageHeader>
          <SelectUserType />
        </$ContentContainer>
      </GuestLayout>
    </AnalyticsProvider>
  );
}
